module.exports = __webpack_public_path__ + "static/img/premiere.03926ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/autoshoplogo/premiere.jpg
// module id = 2jjt
// module chunks = 0